import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import Icon from '../Icon';

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix' | 'suffix'> & {
    label?: string;
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
};

export default function TextField({ label, type = 'text', className, prefix, suffix, ...props }: Props) {
    const [show, setShow] = useState(false);
    const isPassword = type === 'password';
    const hasPrefix = Boolean(prefix);
    const hasSuffix = Boolean(suffix) || isPassword;
    const isNonEditable = !!props.readOnly || !!props.disabled;

    return (
        <label className="block">
            {label && (
                <span className="mb-1 block text-xs font-normal uppercase tracking-wide text-gray-500 dark:text-gray-400">
                    {label}
                </span>
            )}
            <div className="relative">
                <input
                    {...props}
                    type={isPassword ? (show ? 'text' : 'password') : type}
                    className={[
                        'form-control h-9 py-0',
                        hasPrefix ? 'pl-12' : 'pl-3',
                        hasSuffix ? 'pr-12' : 'pr-3',
                        isNonEditable ? (props.onClick ? 'cursor-pointer bg-white dark:bg-gray-800' : '!cursor-not-allowed') : '',
                        className || '',
                    ].join(' ')}
                />
                {hasPrefix && (
                    <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-300 w-5 h-5 flex items-center justify-center">
                        {prefix}
                    </span>
                )}
                {isPassword && (
                    <button
                        type="button"
                        aria-label={show ? 'Hide password' : 'Show password'}
                        onClick={() => setShow((s) => !s)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
                    >
                        {show ? <Icon icon={FiEyeOff} /> : <Icon icon={FiEye} />}
                    </button>
                )}
                {!isPassword && suffix && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-300 w-5 h-5 flex items-center justify-center">
                        {suffix}
                    </div>
                )}
            </div>
        </label>
    );
}
